const STORAGE_KEY = 'orgFeatures';

export function readOrgFeatures() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function readOrgZavvyEnabled() {
  return readOrgFeatures()?.zavvy_focus_enabled === true;
}

/** Persist the login payload. A missing flag is off, so an old session cannot stay on. */
export function storeOrgFeatures(features) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    zavvy_focus_enabled: features?.zavvy_focus_enabled === true,
  }));
}

export function clearOrgFeatures() {
  localStorage.removeItem(STORAGE_KEY);
}

function choiceKey() {
  const orgId = localStorage.getItem('organizationId') || '';
  return orgId ? `focusModeChoice:${orgId}` : 'focusModeChoice';
}

export function readFocusChoice() {
  try {
    return localStorage.getItem(choiceKey());
  } catch {
    return null;
  }
}

export function writeFocusChoice(choice) {
  localStorage.setItem(choiceKey(), choice);
}

export function isZavvyDisabledError(err) {
  const status = err?.status || err?.response?.status;
  if (status !== 403) return false;
  const detail = err?.response?.data?.detail;
  const code = err?.code
    || err?.response?.data?.code
    || (detail && typeof detail === 'object' ? detail.code : null);
  return code === 'zavvy_disabled';
}

let applied = false;

/** Remember that this organisation is off and show classic Focus Mode. */
export function applyZavvyDisabled() {
  if (applied) return;
  applied = true;
  storeOrgFeatures({ zavvy_focus_enabled: false });
  if (window.location.pathname === '/view/focus') {
    window.location.reload();
    return;
  }
  window.location.assign('/view/focus');
}

export function resetZavvyDisabledGuard() {
  applied = false;
}
